import packageJson from "../../package.json" with { type: "json" };

export const APP_VERSION = (packageJson as { version?: string }).version || "0.0.0";
export const APP_NAME = (packageJson as { name?: string }).name || "live-flow-scribe";
